<template>
  <font-awesome-icon :icon="Icon" />
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { Icons } from "../../../constants";

export default {
  name: "BlaiseIcon",
  props: {
    icon: String
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    Icon() {
      return Icons[this.icon];
    }
  }
};
</script>